import { render } from "./BoardForm.vue?vue&type=template&id=518e6836&scoped=true"
import script from "./BoardForm.vue?vue&type=script&lang=js"
export * from "./BoardForm.vue?vue&type=script&lang=js"

import "./BoardForm.vue?vue&type=style&index=0&id=518e6836&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518e6836"]])

export default __exports__